<template>
  <div class="document-dialog" v-if="showShowPrompt">
    <el-dialog
      :visible.sync="showShowPrompt"
      top="30vh"
      :center="false"
      width="360px"
      style="border-radius:15px"
      :close-on-click-modal="false"
      :before-close="close"
    >
      <div slot="title" class="dialog-title ml5 left">温馨提示</div>
      <div class="login-tip">{{ showMessage }}</div>
      <div slot="footer" class="dialog-footer ml5 center">
        <el-button size="mini" class="dialog-tologin" @click="tologin"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "showLogin",
  props: {
    showShowPrompt: {
      type: Boolean,
      default: false
    },
    showMessage: {
      type: String,
      default: ""
    }
  },
  methods: {
    tologin() {
      this.close();
    },
    close() {
      this.$emit("closeShowPrompt", false);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
.document-dialog {
  .login-tip {
    text-align: center;
    margin: 10px 0;
    line-height: 22px;
  }
  .dialog-tologin {
    background-color: @theme-color;
    color: white;
    border-radius: 20px;
    padding: 8px 20px;
  }
  .dialog-document .dialog-title {
    font-size: 14px;
  }
  /deep/.el-dialog__header {
    border-bottom: 1px solid #e2e3e5;
    padding: 15px 20px 15px;
  }
  /deep/.el-dialog {
    border-radius: 4px;
  }
  /deep/.el-dialog__body {
    padding: 20px 20px 0 20px;
  }
}
</style>
